import moment from "moment";
import useLocales from "src/hooks/useLocales";
import { EntityAuthField } from "src/services/link/queries/NetTypes";
import * as Yup from "yup";

export const useFieldValidation = (fields: EntityAuthField[], fieldSelected: string) => {
	const { translate } = useLocales();

	const getFieldValidationSchema = (field: EntityAuthField) => {
		let validator: Yup.AnySchema = Yup.mixed();

		switch (field.type) {
			case "text":
				validator = Yup.string();
				break;
			case "password":
				let passwordValidator: Yup.StringSchema = Yup.string();
				if (field.validations && field.validations.length > 0) {
					field.validations.forEach((validationRule) => {
						if (validationRule.validation && validationRule.message) {
							try {
								const regex = new RegExp(validationRule.validation);
								passwordValidator = passwordValidator.matches(regex, validationRule.message);
							} catch (error) {
								console.error(
									`Invalid regex for field ${field.name}: ${validationRule.validation}`,
									error
								);
							}
						}
					});
				}
				validator = passwordValidator; // Asignamos el resultado de vuelta a validator
				break;
			case "date":
				validator = Yup.date()
					.max(moment().add(-18, "years"), translate("dynamic_form.date_valid"))
					.min(moment().add(-100, "years"), translate("dynamic_form.date_valid"));
				break;
			default:
				validator = Yup.mixed();
		}

		return validator.required(translate("dynamic_form.required_field", { value: field.label }));
	};

	return fields
		.filter(
			(field) =>
				field.type !== "select" &&
				field.type !== "radio" &&
				(field.visibility === null ||
					(field.visibility !== null &&
						(!field.options || field.options.length === 0) &&
						field.visibility.values?.includes(fieldSelected)))
		)
		.reduce(
			(schemaFields, field) => {
				schemaFields[field.name] = getFieldValidationSchema(field);
				return schemaFields;
			},
			{} as { [key: string]: Yup.AnySchema }
		);
};
